const accordion = {
	
	ui: {},

	init: function() {
		const accordions = document.querySelectorAll('.js-accordion');
		
		accordions.forEach(accordion => {
			const triggers = accordion.querySelectorAll('.js-accordion-trigger');
			triggers.forEach((trigger) => {
				trigger.addEventListener('click', () => {
					triggers.forEach(t => t.classList.remove('--active'));
					trigger.classList.add('--active');

					const targetIndex = trigger.getAttribute('data-index');
					const targets = accordion.querySelectorAll('.js-accordion-target');
					targets.forEach(target => target.classList.remove('--active'));

					const activeTarget = accordion.querySelector(`.js-accordion-target[data-index="${targetIndex}"]`);
					if (activeTarget) {
						activeTarget.classList.add('--active');
					}
				});
			});
		});
	},
};

module.exports = accordion;